import { useMutation, useQueryClient } from '@tanstack/react-query';

import type {
  PatchAdminV1StoresStoreIdTaxRatesIdBody,
  PostAdminV1StoresStoreIdTaxRatesBody,
} from '@nucleus-commerce/api-client/admin';

import { taxApi } from '../api/tax-api';

import { taxKeys } from './tax-keys';

export function useCreateTaxRate(storeId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: PostAdminV1StoresStoreIdTaxRatesBody) => taxApi.create(storeId, body),
    meta: { successMessage: 'tax:toasts.created', silentError: true },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: taxKeys.all(storeId) }),
  });
}

export function useUpdateTaxRate(storeId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: PatchAdminV1StoresStoreIdTaxRatesIdBody }) =>
      taxApi.update(storeId, id, body),
    meta: { successMessage: 'tax:toasts.updated', silentError: true },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: taxKeys.all(storeId) }),
  });
}

export function useDeleteTaxRate(storeId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => taxApi.remove(storeId, id),
    meta: { successMessage: 'tax:toasts.deleted', silentError: true },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: taxKeys.all(storeId) }),
  });
}
